import { refs, domReady } from '../modules/utils.js';

class HeaderText extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.scroll?.addEventListener('click', () => {
      const nextSection = this.parentElement.nextElementSibling;
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
}

customElements.define('header-text', HeaderText);
